import { css } from "@emotion/react";

export const container = css`
  height: 100vh;
  height: 100svh;

  video {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    height: 200%;
    width: calc(2.6 * (100% - 64px));

    @media (min-width: 600px) {
      height: 100%;
    }
  }
`;
